import { Language, TemplateSubType, TemplateType } from '../../../types/dto-app';

export const leaseContractRejectedTemplates = [
  {
    id: '-106001',
    language: Language.EN,
    subject: 'The signature of your lease contract has been rejected',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_CONTRACT_REJECTED,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Dear {{listAllTenants lease}},</p>
        <p></p>
        <p>Concerns: signature rejection regarding the lease located at <strong>{{getLeaseMainAddress lease}}</strong>.</p>
        <p></p>
        <p>For your information, one of the stakeholders rejected the current version of the contract with the following message:</p>
        <p><i>{{rejectReason}}</i></p>
        <p></p>
        <p>Kind regards,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
        `,
  },
  {
    id: '-106002',
    language: Language.FR,
    subject: 'La signature de votre contrat de location a été rejetée',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_CONTRACT_REJECTED,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Cher/Chère {{listAllTenants lease}},</p>
        <p></p>
        <p>Concerne: rejet de la signature du bail sis <strong>{{getLeaseMainAddress lease}}</strong>.</p>
        <p></p>
        <p>Pour votre information, un des signataires a rejeté la version actuelle du contrat avec le message suivant:</p>
        <p><i>{{rejectReason}}</i></p>
        <p></p>
        <p>Bien à vous,</p>
        <p></p>
        <p>{{accountSignature client}}</p>`,
  },
  {
    id: '-106003',
    language: Language.NL,
    subject: 'De ondertekening van uw huurcontract is geweigerd',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_CONTRACT_REJECTED,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Geachte {{listAllTenants lease}},</p>
        <p></p>
        <p>Betreffende: de ondertekening van uw huurcontract gelegen te <strong>{{getLeaseMainAddress lease}}</strong> werd verworpen.</p>
        <p></p>
        <p>Ter informatie, een van de belanghebbenden heeft de huidige versie van het contract verworpen met het volgende bericht:</p>
        <p><i>{{rejectReason}}</i></p>
        <p></p>
        <p>Met vriendelijke groeten,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
        `,
  },
  {
    id: '-106004',
    language: Language.DE,
    subject: 'Die Unterzeichnung Ihres Mietvertrags wurde abgelehnt',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_CONTRACT_REJECTED,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Liebe/r {{listAllTenants lease}},</p>
        <p></p>
        <p>Betreff: Ablehnung der Unterzeichnung bezüglich des Mietvertrags in <strong>{{getLeaseMainAddress lease}}</strong>.</p>
        <p></p>
        <p>Zu Ihrer Information: Eine der beteiligten Parteien hat die aktuelle Version des Vertrags mit folgender Nachricht abgelehnt:</p>
        <p><i>{{rejectReason}}</i></p>
        <p></p>
        <p>Mit freundlichen Grüßen,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
        `,
  },
];
